<template>
  <div class="transport_number" :class="formGroupClass">
    <slot name="before"/>
    <div v-if="transport.errorType" class="form-fielderror trailer-error">
      <label>!</label>
      <div class="form-fielderror-text">
        <div>Грузовые автомобили и спецтехника должны оформляться в отдельной заявке</div>
      </div>
    </div>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :id="inputId"
      :disabled="disabled"
      class="form-control show-tick"
      @input="emit"
      @change="emit"
      @blur="emit"
    >
      <template v-for="transportType in transportTypes">
        <option
          v-if="transportType.id !== 'pedestrian' && Number(transportType.visible) === 1"
          :key="transportType.id"
          :value="transportType.id"
        >{{ transportType.name }}
        </option>
      </template>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import transportInputMixin from '../../../../mixins/application-form/transportInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TransportTypeInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    transportInputMixin
  ],

  props: {
    transportTypes: {
      type: Array,
      default: () => []
    },

    inputLabel: {
      default: 'Вид транспортного средства (ТС)'
    },

    inputName: {
      default: 'type'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputId() {
      return `form-visitor-transport-type-${this.visitorIndex}-${this.transportIndex}`
    }
  }
}
</script>
